import { z } from "zod";
import { BladeCommonSchema } from "../../../types";
import { RichTextSchema } from "../../RichText";
import { ImageMediaSchema } from "../../../components/Media";
import { IconLinkSchema } from "../../IconLink";
import { LinkItemSchema } from "../../LinkItem";
const AuthorSchema = z.object({
    name: z.string(),
});
export const ArticleMastheadBladeSchema = BladeCommonSchema.extend({
    banner: ImageMediaSchema,
    title: z.string(),
    description: RichTextSchema.optional(),
    publishDate: z.string(),
    category: LinkItemSchema.optional(),
    socialLinks: z.array(IconLinkSchema).optional(),
    tags: z.array(LinkItemSchema).optional(),
    authors: z.array(AuthorSchema).optional(),
});
//# sourceMappingURL=index.js.map